import { FailedInfraResponse } from "~/api/_common/InfraResponse"
import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

const PATH = "/student/message_connection/unread_message_connection_count"

type GetStudentMessageConnectionUnreadMessageConnectionCount = FailedInfraResponse | UnreadMessageConnectionCount

export const fetchGetStudentMessageConnectionUnreadMessageConnectionCount = defineFetcher(
  (): Promise<GetStudentMessageConnectionUnreadMessageConnectionCount> => {
    return GET(PATH)
  }
)

export type UnreadMessageConnectionCount = {
  error?: undefined
  count: number
}
